import { snakeCase } from 'lodash';

export const getActionType = (actionName, moduleName = 'STAFF_DASHBOARD') =>
  `${moduleName}/${snakeCase(actionName).toUpperCase()}`;

export const createActionCreator = actionName => payload => ({
  type: getActionType(actionName),
  ...payload,
});

export const findOneAndUpdate = (arr, idProp, uniqId, update) => {
  const i = arr.findIndex(el => el[idProp] === uniqId);

  if (i === -1) return arr;

  return [...arr.slice(0, i), { ...arr[i], ...update }, ...arr.slice(i + 1)];
};
